import { membersCleanupService } from '../services'

const state = {
    stat: {
        loading: false,
        data: {},
    },
    remove: {
        loading: false,
    }
}

const actions = {

    load ({ dispatch, commit }) {
        commit('loadStatRequest')
        membersCleanupService.load().then(
            response => {
                commit('loadStatSuccess', response)
            },
            error => {
                commit('loadStatError')
                dispatch('alert/error', 'Unable to load members data: ' + error, { root: true })
            }
        )
    },

    remove ({ dispatch, commit }) {
        commit('removeRequest')
        return membersCleanupService.remove().then(
            response => {
                commit('removeSuccess', response)
                dispatch('alert/success', 'Removal process has started.', { root: true })
            },
            error => {
                commit('removeError')
                dispatch('alert/error', 'Unable to perform request: ' + error, { root: true })
            }
        )
    },

}

const mutations = {
    loadStatRequest (state, params) {
        state.stat = {loading: true, data: {}}
    },
    loadStatSuccess (state, data) {
        state.stat = { loading: false, data: data.stat }
    },
    loadStatError (state) {
        state.stat = {loading: false, data: {}}
    },
    removeRequest(state) {
        state.remove.loading = true
    },
    removeSuccess(state) {
        state.remove.loading = false
    },
    removeError(state) {
        state.remove.loading = false
    },
}

const getters = {
    isLoadingStat (state) {
        return state.stat.loading === true
    },
    getStat (state) {
        return state.stat.data
    },
}

export const membersCleanupModule = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
